export const MIN_WIDTH = 380;
export const MAX_WIDTH = 380;
export const WIDTH = 380;
